import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from '../../../components/Button';
import messages from '../../messages';
import { AdditionalItem } from './AdditionalItem';

export class AdditionalList extends React.Component {
  componentDidMount() {
    if (this.props.data.length <= 0) {
      this.addItem();
    }
  }

  onRemove = (id) => {
    let arrayData = this.props.data;

    // find and remove item from data by id
    arrayData = arrayData.filter((t) => t.id !== id);

    this.onChange(arrayData);
  };

  onItemChanged = (itemChanged) => {
    const item = this.props.data.filter((t) => t.id === itemChanged.id)[0];

    if (item) {
      // find and update item by id
      const newData = this.props.data.map(
        (el) =>
          el.id === itemChanged.id ? Object.assign({}, el, itemChanged) : el
      );

      this.onChange(newData);
    }
  };

  onChange = (data) => {
    if (this.props.onChange) {
      this.props.onChange(data);
    }
  };

  addItem = () => {
    const arrayData = this.props.data;

    arrayData.push({
      id: new Date().getTime().toString(),
      selectedClaimFor: [],
      descriptionOfItem: '',
      dateOfExpenses: '',
      amountClaimed: '',
      currency: '',
      haveYouReceivedAnyCreditOrRefundFromTheServiceProvider: 'false',
      amountCreditedOrRefunded: '',
      currencyCreditedOrRefunded: '',
    });

    this.onChange(arrayData);
  };

  render() {
    const { data } = this.props;
    const { isDelayed, disabled } = this.props;
    const removable = data.length > 1;

    return (
      <div >
        <div style={{ backgroundColor: '#d1d1d1' }}>
          {data.map((item, index) => (
            <AdditionalItem
              {...this.props}
              index={index}
              key={item.id}
              item={item}
              onChange={this.onItemChanged}
              onRemove={this.onRemove}
              isDelayed={isDelayed}
              disabled={disabled}
              removable={removable}
            />
          ))}
        </div>
        {!disabled && (
          <div className="ml-2 row">
            <div className="col-auto">
              <Button onClick={this.addItem}>
                <FormattedMessage {...messages.addItem} />
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

AdditionalList.propTypes = {
  onChange: PropTypes.func,
  data: PropTypes.array,
  isDelayed: PropTypes.bool,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.RentalVehicleExcess/components/Additional/index.js